import React, { useEffect, useState } from 'react';
import { Container, Typography, Paper, Toolbar, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { MerchantActions, NotificationActions } from '../../../store';
import MerchantStepOne from './MerchantStepOne';
import MerchantStepTwo from './MerchantStepTwo';
import MerchantStepThree from './MerchantStepThree';
import MerchantStepFour from './MerchantStepFour';
import MerchantStepFive from './MerchantStepFive';
import MerchantStepSix from './MerchantStepSix';
import MerchantStepSeven from './MerchantStepSeven';


const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})


const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;



const MerchantExaminationOK = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token } = useSelector(IdentitySelector);

    const { classes } = props;
    //step
    const [activeStep, setActiveStep] = React.useState(0);

    //next button 
    const handleNext = () => {
        if (activeStep == 6) {
            props.onCancel();
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    //back button
    const handleBack = () => {
        if (activeStep == 0) {
            props.onCancel();
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
           
    };


    /* change the steps */
    const getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return <MerchantStepOne onChange={onChange} handleNext={handleNext} handleBack={handleBack} mode="regist" />
            case 1:
                return <MerchantStepTwo onChange={onChange} handleNext={handleNext} handleBack={handleBack} mode="regist" />
            case 2:
                return <MerchantStepThree onChange={onChange} handleNext={handleNext} handleBack={handleBack} mode="regist" />
            case 3:
                return <MerchantStepFour onChange={onChange} handleNext={handleNext} handleBack={handleBack} mode="regist" />
            case 4:
                return <MerchantStepFive onChange={onChange} handleNext={handleNext} handleBack={handleBack} />
            case 5:
                return <MerchantStepSix onChange={onChange} handleNext={handleNext} handleBack={handleBack} />
            case 6:
                return <MerchantStepSeven onChange={onChange} handleNext={handleNext} handleBack={handleBack} />
            default:
                return 'Unknown stepIndex';
        }
    }

    /* change the title */
    const getTitle = (index) => {
        switch (index) {
            case 0:
                return <FormattedMessage id="Merchant.StepOneTitle" />
            case 1:
                return <FormattedMessage id="Merchant.StepTwoTitle" />
            case 2:
                return <FormattedMessage id="Merchant.StepThreeTitle" />
            case 3:
                return <FormattedMessage id="Merchant.StepFourTitle" />
            case 4:
                return <FormattedMessage id="Merchant.StepFiveTitle" />
            case 5:
                return <FormattedMessage id="Merchant.StepSixTitle" />
            default:
                return 'Unknown Title';
        }
    }


    var stepper;
    if (activeStep <= 5) {
        stepper = <div>
            <Stepper className={classes.form} activeStep={activeStep} alternativeLabel>
                <Step key={<FormattedMessage id="Merchant.StepOne" />}>
                    <StepLabel>{<FormattedMessage id="Merchant.StepOne" />}</StepLabel>
                </Step>
                <Step key={<FormattedMessage id="Merchant.StepTwo" />}>
                    <StepLabel>{<FormattedMessage id="Merchant.StepTwo" />}</StepLabel>
                </Step>
                <Step key={<FormattedMessage id="Merchant.StepThree" />}>
                    <StepLabel>{<FormattedMessage id="Merchant.StepThree" />}</StepLabel>
                </Step>
                <Step key={<FormattedMessage id="Merchant.StepFour" />}>
                    <StepLabel>{<FormattedMessage id="Merchant.StepFour" />}</StepLabel>
                </Step>
                <Step key={<FormattedMessage id="Merchant.StepFive" />}>
                    <StepLabel>{<FormattedMessage id="Merchant.StepFive" />}</StepLabel>
                </Step>
                <Step key={<FormattedMessage id="Merchant.StepSix" />}>
                    <StepLabel>{<FormattedMessage id="Merchant.StepSix" />}</StepLabel>
                </Step>
            </Stepper>

            <Toolbar variant="regular">
                <div>
                    <Typography component="h1" variant="inherit">{getTitle(activeStep)}</Typography>
                </div>
            </Toolbar>
        </div>;
    }


   /* if (editing == null) {
        return <div></div>;
    }*/

    /* on change input*/
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;
        currentState[name] = value;
        return value;
    }
    
    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                {stepper}
                {getStepContent(activeStep)}
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantExaminationOK);
